import { useState } from 'react';
import type { Project, ProjectTypology } from '@/types/content';
import { GalleryCard } from './GalleryCard';

interface GalleryGridProps {
  projects: Project[];
  showFilter?: boolean;
}

const FILTERS: Array<{ label: string; value: 'all' | ProjectTypology }> = [
  { label: 'All', value: 'all' },
  { label: 'Residential', value: 'residential' },
  { label: 'Commercial', value: 'commercial' },
  { label: 'Hospitality', value: 'hospitality' },
];

export function GalleryGrid({ projects, showFilter = true }: GalleryGridProps) {
  const [filter, setFilter] = useState<'all' | ProjectTypology>('all');
  const visible = filter === 'all' ? projects : projects.filter((p) => p.typology === filter);

  return (
    <div className="gallery-grid-wrapper">
      {showFilter ? (
        <div className="gallery-filter" role="tablist" aria-label="Project typology filter">
          {FILTERS.map((f) => (
            <button
              key={f.value}
              role="tab"
              aria-selected={filter === f.value}
              onClick={() => setFilter(f.value)}
              className={`gallery-filter__btn ${filter === f.value ? 'is-active' : ''}`}
            >
              {f.label}
            </button>
          ))}
        </div>
      ) : null}
      <div className="gallery-grid">
        {visible.map((p, i) => (
          <GalleryCard key={p.slug} project={p} index={i} priority={i === 0} />
        ))}
      </div>
      {visible.length === 0 ? (
        <p className="caption">No projects of this typology yet — check back soon.</p>
      ) : null}
    </div>
  );
}
